import { AccountType } from "./getAccountType";
var isOverlay = function (_a) {
    var isRegistered = _a.isRegistered, accountType = _a.accountType, conditions = _a.conditions;
    return !isRegistered &&
        conditions.includes("AUTH_PROHIBITED") &&
        (accountType === AccountType.CARD || accountType === AccountType.LOAN);
};
export default isOverlay;
//# sourceMappingURL=isOverlay.js.map